import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/others/BreadCrumbs";
import GlobalStyles from "../../global/GlobalStyles";
import { useParams } from "react-router-dom";
import api from "../../global/api";
import ProfileDetailsCard from "../../components/others/ProfileDetailsCard";
import BigLoader from "../../components/loaders/BigLoader";

const UserDetails = () => {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);

  const getUser = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/user/${id}`);
      setUser(response.data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const breadcrumbItems = [
    { name: "Dashboard", path: "/admin/dashboard" },
    { name: "Manage users", path: "/admin/dashboard/manage-users" },
    {
      name: "User",
      path: `/admin/dashboard/manage-users/${id}`,
    },
  ];

  useEffect(() => {
    getUser();
    // eslint-disable-next-line
  }, []);

  return (
    <div className={GlobalStyles.dashbooardPageContainer}>
      <div className={GlobalStyles.dashbooardPageWrap}>
        <div className={GlobalStyles.seperator}>
          <Breadcrumbs items={breadcrumbItems} />
        </div>
        {loading && (
          <div className="w-full flex justify-center py-40">
            <BigLoader />
          </div>
        )}
        {user && (
          <div className="w-full flex justify-center">
            <div className="w-full md:w-2/3 lg:w-1/2">
              <ProfileDetailsCard
                user={user}
                setLoading={setLoading}
                personal={false}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserDetails;
